import PropTypes from 'prop-types'

import { OrderTypes } from '../../models/orders/order-types-enum.js'
import { idPropType } from '../common/id-prop-type'
import { orderAddressPropType } from './order-address-prop-type'
import { orderContactPropType } from './order-contact-prop-type'

/**
 * This is the order template data model type definition.
 *
 * @typedef {Object} OrderTemplate
 * @property {number} [arrivalTolerance] - the arrival tolerance for the planned arrival time
 * @property {OrderContact} [contact] - the contact info for the order template
 * @property {string} [description] - description of the order template
 * @property {OrderAddress} [destinationAddress] - the address for the order template
 * @property {string} [estimatedWorkDuration] - the estimated duration needed for the order template
 * @property {string} [executionTime] - the planned arrival time
 * @property {number} [lastModified] - timestamp of the last change
 * @property {Id} [lastModifiedUserId] - id of the user who last changed this template
 * @property {Id} [orderTemplateId] - the id of the order template
 * @property {string} [orderType] - the type of the order template
 * @property {string} [suggestedExecutionTime] - the estimated arrival time for the order template
 */
export const orderTemplatePropType = PropTypes.shape({
    arrivalTolerance: PropTypes.number,
    contact: orderContactPropType,
    description: PropTypes.string,
    destinationAddress: orderAddressPropType,
    estimatedWorkDuration: PropTypes.string,
    executionTime: PropTypes.string,
    lastModified: PropTypes.number,
    lastModifiedUserId: idPropType,
    orderTemplateId: idPropType,
    orderType: PropTypes.oneOf(Object.values(OrderTypes)),
    suggestedExecutionTime: PropTypes.string
})
